import { useConsent } from "../lib/consent";
import { Button, Icon } from "./ui";

/**
 * Gates analytics and ads behind an explicit choice, shown once until answered. Nothing in
 * either category loads before this — no GA script, no AdSense script, no cookie — and
 * rejecting leaves the app working exactly the same as accepting; the only thing consent
 * controls is measurement and ads.
 *
 * Lives outside <App> in main.tsx so it appears regardless of auth state — a visitor should be
 * asked before they've even signed in, not after. It sits above the mobile tab bar rather than
 * over it, so it never blocks navigation while it's up.
 */
export function ConsentBanner() {
  const { preferences, acceptAll, rejectAll } = useConsent();
  if (preferences) return null;

  return (
    <div
      role="dialog"
      aria-modal="false"
      aria-label="Cookie and privacy preferences"
      className="animate-in fixed inset-x-3 bottom-[5.5rem] z-50 mx-auto max-w-xl rounded-2xl border border-line bg-surface p-4 shadow-pop sm:bottom-4 sm:p-5"
    >
      <div className="flex items-start gap-3">
        <span className="grid size-9 shrink-0 place-items-center rounded-xl bg-accent-soft text-accent-text">
          <Icon name="shield" className="size-[18px]" />
        </span>
        <p className="text-sm leading-relaxed text-fg-muted">
          We'd like to use analytics to understand how the app is used, and to show occasional,
          clearly-labelled ads to help cover hosting. Both are optional and start switched off.
        </p>
      </div>

      <div className="mt-4 flex justify-end gap-2">
        <Button variant="ghost" size="sm" onClick={rejectAll}>
          Reject
        </Button>
        <Button size="sm" onClick={acceptAll}>
          Accept
        </Button>
      </div>
    </div>
  );
}
